import React, { useEffect, useMemo, useRef, useState } from "react";
import PropTypes from "prop-types";

import {
  // EyeIcon,
  FinishingText,
  // GameOverIcon,
  // GoButton,
  LinkContainer,
  LinkTextFieldContainer,
  LinkTextInputField,
  TextFieldSingleSuggestion,
  TextFieldSingleSuggestionText,
  TextFieldSingleSuggestionTextHighlighted,
  TextFieldSuggestionsContainer,
  LinkCommandContainer,
  LinkCommand,
  // HintIcon,
  // GiveUpIcon
} from "./LinkTextField.styled";
// import { PlayerCommandsContainer } from "../../GuessSongField/GuessSongField.styled";
// import DiscLosingProgress from "../../DiscLosingProgress/DiscLosingProgress";
// import LinkLosingProgress from "../../LinkLosingProgress/LinkLosingProgress";
import { useDispatch, useSelector } from "react-redux";
import { selectLinks } from "../../../store/selectors/gameSelectors";
import {
  fetchGuessLink,
  fetchListLinks,
} from "../../../store/actions/game/gameActions";
import gameStates from "../../../constants/gameStates";
import {
  CORRECT_FIELD_STATE,
  INITIAL_FIELD_STATE,
  // OVER_FIELD_STATE,
  WRONG_FIELD_STATE,
  GAVEUP_FIELD_STATE,
} from "../../../constants/fieldStates";
// import selectedTheme from "../../../themes";
import {
  // ClueButton,
  LinkGuessContainer,
} from "../../../contents/PlayContent/PlayContent.styled";
// import CircleCommand from "../../CircleCommand/CircleCommand";

//firebase analytics
import { logEvent } from "firebase/analytics";
import { analytics } from "../../../index";

const LinkTextField = (props) => {
  const containerRef = useRef(null);
  const [placeholder, setPlaceholder] = useState(
    "Answer 3 songs to guess the link"
  );
  const [isFocused, setIsFocused] = useState(false);
  const [fieldState, setFieldState] = useState(INITIAL_FIELD_STATE);
  const [linkLives, setLinkLives] = useState(3);
  const [gameState, setGameState] = useState(gameStates.INITIAL); //tracking status of game...you can lose === 1 or win === 2
  const [value, setValue] = useState("");
  const [isShowingHintOptions, setIsShowingHintOptions] = useState(false);
  const dispatch = useDispatch();
  const answers = useSelector(selectLinks);
  const [isShowThingsOrPhrases, setIsShowThingsOrPhrases] = useState(false);
  const [isShowTitlesOrArtists, setIsShowTitlesOrArtists] = useState(false);
  const [isShowWords, setIsShowWords] = useState(false);

  useEffect(() => {
    // Reset all internal states to their initial values
    setPlaceholder("Answer 3 songs to guess the link");
    setIsFocused(false);
    setFieldState(INITIAL_FIELD_STATE);
    setLinkLives(3);
    setGameState(gameStates.INITIAL);
    setIsShowingHintOptions(false);
    setIsShowThingsOrPhrases(false);
    setIsShowTitlesOrArtists(false);
    setIsShowWords(false);

    // Delay resetting the value to avoid interfering with the song player
    const timer = setTimeout(() => {
      setValue("");
    }, 100);

    return () => clearTimeout(timer);
  }, [props.questionId]);

  const values = useMemo(() => {
    if (value?.length === 0) return [];
    return answers || [];
  }, [answers, value]);

  useEffect(() => {
    if (value?.length > 0)
      dispatch(
        fetchListLinks({
          searchTerm: value,
        })
      );
  }, [value]);
  const finishingTextFirst = useMemo(() => {
    if (gameState === gameStates.WON) return `You guessed the link :)`;
    return `You didn't guess the link :(`;
  }, [props?.totalLives, gameState]);
  const finishingTextSecond = useMemo(() => {
    if (gameState === gameStates.WON) {
      return `Challenge a friend to beat your time`;
    } else if (gameState === gameStates.LOST) {
      return `Challenge a friend`;
    }
  }, [props?.totalLives, gameState]);

  const onFocusHandler = () => {
    if (props?.solvedFields < 3 || fieldState === GAVEUP_FIELD_STATE) {
      return;
    }
    if (fieldState === WRONG_FIELD_STATE && value === "Try Again") setValue("");
    setIsFocused(true);
  };
  // const onBlurHandler = () => {
  //   setPlaceholder("Guess the link");
  // };
  const onChange = (event) => {
    if (gameState === gameStates.INITIAL) setValue(event?.target?.value);
  };

  // const checkFocus = (event) => {
  //   if (containerRef.current && !containerRef.current.contains(event.target)) {
  //     setPlaceholder("Answer 3 songs to guess the link");
  //     setIsFocused(false);
  //     // console.log(value?.length);
  //     // console.log(fieldState);
  //     if (fieldState === WRONG_FIELD_STATE && value?.length === 0)
  //       setValue("Try Again");
  //   }
  //   else{
  //     setIsFocused(true)
  //   }
  // };
  const isCorrectAnswer = (guess) => {
    return props?.answers?.includes(guess);
  };

  const loseLife = () => {
    props?.loseLife();
    // if (linkLives > 1) {//we don't need anymore to track lives because now user can try infinity times to hit the link!!!
    setFieldState(WRONG_FIELD_STATE);
    setLinkLives((prevLives) => prevLives - 1);
    setValue("Try Again");
    // }
    // else {
    //   setFieldState(OVER_FIELD_STATE);
    //   setLinkLives(0);
    //   setGameState(gameStates.LOST);
    //   props?.gameOver();
    //   setValue(props?.answers?.[0]);
    // }
  };

  const winGame = (guess) => {
    setValue(guess);
    setGameState(gameStates.WON);
    setFieldState(CORRECT_FIELD_STATE);
    props?.gameOver();
    props.handleSetGameState(gameStates.WON);

    logEvent(analytics, "Link_guess_correct", {
      content_type: `Link_guess_correct`,
      item_id: `${guess}`,
      debug_mode: true,
    });
  };

  const handleGuessLink = (event, linkGuess) => {
    setIsFocused(false);
    dispatch(
      fetchGuessLink({
        answer: linkGuess,
        id: props?.questionId,
      })
    );
    if (isCorrectAnswer(linkGuess)) {
      winGame(linkGuess);
    } else {
      loseLife();
      logEvent(analytics, "Link_guess_incorrect", {
        content_type: `wrong_link_guess`,
        item_id: `${linkGuess}`,
        debug_mode: true,
      });
    }
  };
  const handleGiveUp = () => {
    if (props?.solvedFields < 3) {
      //linkTextField needs to be visible always but it can't make any action before minimum 3 songs are revealed
      return;
    }
    for (let i = 0; i < linkLives; i++) {
      props?.loseLife();
    }
    setFieldState(GAVEUP_FIELD_STATE);
    setLinkLives(0);
    setGameState(gameStates.LOST);
    props?.gameOver();
    setValue(props?.answers?.[0]);
    props.handleSetGameState(gameStates.LOST);

    logEvent(analytics, "Give_Up_selected", {
      content_type: "give_up_link",
      debug_mode: true,
    });
  };

  const handleRevealClues = () => {
    if (props?.solvedFields < 3) {
      return;
    }
    props?.revealClues(10);
    // setPlaceholder("Guess the link");
    // logEvent(analytics, "select_content_clue", {
    //   content_type: `clue`,
    // });
  };

  const handleHintReveal = (hint) => {
    if (hint === "things_or_phrases" && isShowThingsOrPhrases === false) {
      setIsShowThingsOrPhrases(true);
      props?.revealHints(5);
      logEvent(analytics, "Link_hint_1_used", {
        hint_type: "things_or_phrases",
        added_time: 5,
      });
    } else if (
      hint === "titles_or_artists" &&
      isShowTitlesOrArtists === false
    ) {
      setIsShowTitlesOrArtists(true);
    
      props?.revealHints(7);
      props?.revealTitleOrArtistClueHint();
      logEvent(analytics, "Link_hint_2_used", {
        hint_type: "titles_or_artists",
        added_time: 7,
      });
    } else if (hint === "words" && isShowWords === false) {
      setIsShowWords(true);
      props?.revealHints(10);
      props?.revealClueHint();
      logEvent(analytics, "Link_hint_3_used", {
        hint_type: "words",
        added_time: 10,
      });
    }
  };

  // useEffect(() => {
  //   document.addEventListener("mousedown", checkFocus.bind(this));
  //   return () => {
  //     document.removeEventListener("mousedown", checkFocus.bind(this));
  //   };
  // }, []);
  useEffect(() => {
    const input = containerRef.current.children[0].children[0].children[0];

    input.addEventListener("blur", () => {
      if (props.solvedFields < 3) {
        // Ako nema tri tačna odgovora, vrati placeholder na početnu vrednost
        setPlaceholder("Answer 3 songs to guess the link");
      } else {
        setPlaceholder("Guess the link");
      }
    });

    input.addEventListener("click", () => {
      if (props.solvedFields >= 3) {
        setPlaceholder(""); // Tek kad ima tri tačna odgovora, ukloni placeholder
      } else {
        setPlaceholder("Answer 3 songs to guess the link");
      }
    });

    // Ažuriraj placeholder prema uslovima
    if (
      props.solvedFields >= 3 &&
      (fieldState === INITIAL_FIELD_STATE || fieldState === WRONG_FIELD_STATE)
    ) {
      setPlaceholder("Guess the link");
      input.removeAttribute("readonly");
    } else {
      setPlaceholder("Answer 3 songs to guess the link");
      input.setAttribute("readonly", "true");
    }
  }, [props.solvedFields, isFocused, fieldState]);
  const handleShare = () => {
    //sharing data through applications
    const currentUrl = window.location.href;
    const shareText =
      gameState === gameStates.WON
        ? `I solved today's Cryptic DJ after ${props?.scoreTimer}.${props?.decimalTime} seconds of music - can you beat that?`
        : `I played Cryptic DJ today - can you solve the link?`;
    const shareData = {
      title: "Cryptic DJ",
      text: shareText,
      url: currentUrl,
    };
    if (navigator.share) {
      navigator
        .share(shareData)
        .then(() => {
          logEvent(analytics, "Shared_the_game", {
            content_type: `share`,
            item_id: "share from link",
          });
        }) //ovde dodaj toast message!!!
        .catch((err) => console.log(err));
    } else {
      console.log("WEB SHARE API doesn`t work!");
    }
  };
  return (
    <LinkContainer>
      <LinkGuessContainer>
        <LinkTextFieldContainer onFocus={onFocusHandler} ref={containerRef}>
          <LinkTextInputField
            placeholder={placeholder}
            onChange={onChange}
            value={value}
            fieldState={fieldState}
            style={{ width: "80%" }}
            canAnswer={props?.solvedFields >= 3}
            // bgcolor={
            //   fieldState === OVER_FIELD_STATE
            //     ? selectedTheme.colors.incorrectLinkBgColor
            //     : fieldState === CORRECT_FIELD_STATE &&
            //       selectedTheme.colors.correctBgColor
            // }
            inputProps={{ autocomplete: "off" }}
            active={props?.solvedFields >= 3}
            can_try_again={value === "Try Again"}
          />

          {/* {value?.length > 0 && fieldState !== CORRECT_FIELD_STATE && (
          <GoButton onClick={(event) => handleGuessLink(event, value)}>
            GO
          </GoButton>
        )} */}
          {/* {gameState === gameStates.LOST && <GameOverIcon />} */}
          {value?.length > 0 &&
            isFocused &&
            gameState !== gameStates.WON &&
            gameState !== gameStates.LOST && (
              <TextFieldSuggestionsContainer
                onClick={(event) => event.preventDefault()}
              >
                {values?.map((singleValue) => {
                  if (
                    !singleValue?.toLowerCase()?.includes(value?.toLowerCase())
                  )
                    return;
                  const firstValue = singleValue?.slice(
                    0,
                    singleValue?.toLowerCase().indexOf(value?.toLowerCase())
                  );
                  const secondValue = singleValue?.slice(
                    singleValue?.toLowerCase().indexOf(value?.toLowerCase()),
                    singleValue?.toLowerCase().indexOf(value?.toLowerCase()) +
                      value?.toLowerCase()?.length
                  );
                  const thirdValue = singleValue?.slice(
                    singleValue?.toLowerCase().indexOf(value?.toLowerCase()) +
                      value?.toLowerCase()?.length
                  );
                  return (
                    <TextFieldSingleSuggestion
                      key={singleValue}
                      onClick={(event) => handleGuessLink(event, singleValue)}
                    >
                      <TextFieldSingleSuggestionText>
                        {firstValue}
                      </TextFieldSingleSuggestionText>
                      <TextFieldSingleSuggestionTextHighlighted>
                        {secondValue}
                      </TextFieldSingleSuggestionTextHighlighted>
                      <TextFieldSingleSuggestionText>
                        {thirdValue}
                      </TextFieldSingleSuggestionText>
                    </TextFieldSingleSuggestion>
                  );
                })}
              </TextFieldSuggestionsContainer>
            )}
        </LinkTextFieldContainer>
        {props?.solvedFields >= 3 &&
          gameState !== gameStates.WON &&
          gameState !== gameStates.LOST && (
            <LinkCommandContainer>
              {/* <LinkCommand onClick={handleRevealClues}>
              Reveal clues (+ 10 secs)
            </LinkCommand> */}
              {isShowingHintOptions ? (
                <>
                  <LinkCommand
                    onClick={() => handleHintReveal("things_or_phrases")}
                    type={isShowThingsOrPhrases ? "released" : "light-red"}
                  >
                    {isShowThingsOrPhrases
                      ? props?.hints?.things_or_phrases.hint
                      : "Style of link? (+5secs)"}
                  </LinkCommand>
                  <LinkCommand
                    onClick={() => handleHintReveal("titles_or_artists")}
                    type={isShowTitlesOrArtists ? "released" : "light-red"}
                  >
                    {isShowTitlesOrArtists
                      ? "In these Titles or Artists"
                      : "In Title or Artist? (+7secs)"}
                  </LinkCommand>
                  <LinkCommand
                    onClick={() => handleHintReveal("words")}
                    type={isShowWords ? "released" : "light-red"}
                  >
                    {isShowWords ? "These Words" : "Which Words? (+10secs)"}
                  </LinkCommand>
                </>
              ) : (
                <LinkCommand
                  onClick={() => setIsShowingHintOptions(true)}
                  type="light-red"
                >
                  Hints
                </LinkCommand>
              )}
            </LinkCommandContainer>
          )}
        {gameState === gameStates.INITIAL &&
          props?.solvedFields >= 3 &&
          !props.disabled && (
            <LinkCommandContainer
              style={{
                marginTop: "10px",
                paddingTop: "20px",
                flexBasis: "100%",
                borderTop: "2px solid #FFF",
              }}
            >
              <LinkCommand
                onClick={handleGiveUp}
                type="red"
                style={{
                  width: "80%",
                  margin: "0 auto",
                  borderColor: "#e74c3c",
                  backgroundColor: "#e74c3c",
                }}
              >
                Give up and Reveal Answers
              </LinkCommand>
            </LinkCommandContainer>
            // <PlayerCommandsContainer>---------second depricated------------
            //   <LinkLosingProgress noOfLives={linkLives}/>
            //   <HintIcon onClick={handleRevealClues} />
            //   <GiveUpIcon onClick={handleGiveUp} />
            /* <ClueButton>---------first depricated------------
              <CircleCommand
                onClick={props?.revealClues}
                firstCommand={<EyeIcon />}
              />
              {/* <DiscLosingProgress noOfLives={props?.cluesRevealed ? 0 : 3} /> }
            </ClueButton> */
            // </PlayerCommandsContainer>
          )}
      </LinkGuessContainer>
      {gameState !== gameStates.INITIAL && (
        <>
          <FinishingText>{finishingTextFirst}</FinishingText>
          {(gameState === gameStates.WON || gameState === gameStates.LOST) && (
            <FinishingText
              onClick={handleShare}
              style={{
                fontSize: "14px",
                cursor: "pointer",
                textDecoration: "none",
                display: "flex",
                alignItems: "center",
                gap: "15px",
                color: "#FFF",
                padding: "5px 16px",
                background: "#6D52EE",
                fontWeight: "600",
              }}
            >
              {/* {fieldState === CORRECT_FIELD_STATE && <span style={{textDecoration:'underline', fontStyle: 'italic', cursor: 'pointer'}}>Challenge a friend to </span>} */}
              {finishingTextSecond}
              <svg
                width="22"
                height="26"
                viewBox="0 0 22 26"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M22 4.5C22 6.98528 19.9853 9 17.5 9C16.3645 9 15.3272 8.57942 14.5354 7.88553L8.90722 11.5865C8.96804 11.8815 9 12.187 9 12.5C9 12.8529 8.95937 13.1964 8.88254 13.5259L15.206 17.6278C15.8777 17.229 16.6621 17 17.5 17C19.9853 17 22 19.0147 22 21.5C22 23.9853 19.9853 26 17.5 26C15.0147 26 13 23.9853 13 21.5C13 20.9866 13.086 20.4932 13.2443 20.0336L7.19112 16.107C6.44056 16.6679 5.50906 17 4.5 17C2.01472 17 0 14.9853 0 12.5C0 10.0147 2.01472 8 4.5 8C5.58139 8 6.57369 8.38144 7.3497 9.01712L13.0638 5.25965C13.0219 5.0127 13 4.75891 13 4.5C13 2.01472 15.0147 0 17.5 0C19.9853 0 22 2.01472 22 4.5Z"
                  fill="white"
                />
                <mask id="path-2-inside-1_2103_548" fill="white">
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M21 4.5C21 6.433 19.433 8 17.5 8C16.4906 8 15.581 7.57268 14.9422 6.88907L7.86711 11.5414C7.95367 11.8461 8 12.1676 8 12.5C8 12.8726 7.94177 13.2316 7.83393 13.5684L15.5312 18.6059C16.0921 18.2235 16.7699 18 17.5 18C19.433 18 21 19.567 21 21.5C21 23.433 19.433 25 17.5 25C15.567 25 14 23.433 14 21.5C14 20.9425 14.1303 20.4155 14.3622 19.9477L6.88961 15.0573C6.26408 15.6421 5.42384 16 4.5 16C2.567 16 1 14.433 1 12.5C1 10.567 2.567 9 4.5 9C5.46438 9 6.33767 9.39004 6.97071 10.021L14.0998 5.33311C14.0346 5.0661 14 4.78709 14 4.5C14 2.567 15.567 1 17.5 1C19.433 1 21 2.567 21 4.5Z"
                  />
                </mask>
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M21 4.5C21 6.433 19.433 8 17.5 8C16.4906 8 15.581 7.57268 14.9422 6.88907L7.86711 11.5414C7.95367 11.8461 8 12.1676 8 12.5C8 12.8726 7.94177 13.2316 7.83393 13.5684L15.5312 18.6059C16.0921 18.2235 16.7699 18 17.5 18C19.433 18 21 19.567 21 21.5C21 23.433 19.433 25 17.5 25C15.567 25 14 23.433 14 21.5C14 20.9425 14.1303 20.4155 14.3622 19.9477L6.88961 15.0573C6.26408 15.6421 5.42384 16 4.5 16C2.567 16 1 14.433 1 12.5C1 10.567 2.567 9 4.5 9C5.46438 9 6.33767 9.39004 6.97071 10.021L14.0998 5.33311C14.0346 5.0661 14 4.78709 14 4.5C14 2.567 15.567 1 17.5 1C19.433 1 21 2.567 21 4.5Z"
                  fill="black"
                />
                <path
                  d="M14.9422 6.88907L15.6728 6.20632L15.0972 5.59029L14.3927 6.05353L14.9422 6.88907ZM7.86711 11.5414L7.31768 10.7059L6.70466 11.109L6.90519 11.8148L7.86711 11.5414ZM7.83393 13.5684L6.88156 13.2635L6.64944 13.9884L7.28632 14.4052L7.83393 13.5684ZM15.5312 18.6059L14.9836 19.4426L15.5424 19.8084L16.0944 19.4322L15.5312 18.6059ZM14.3622 19.9477L15.2582 20.3918L15.6522 19.5968L14.9098 19.111L14.3622 19.9477ZM6.88961 15.0573L7.43721 14.2206L6.78026 13.7906L6.20671 14.3268L6.88961 15.0573ZM6.97071 10.021L6.26479 10.7293L6.84073 11.3033L7.52014 10.8565L6.97071 10.021ZM14.0998 5.33311L14.6492 6.16865L15.2385 5.78111L15.0712 5.0959L14.0998 5.33311ZM17.5 9C19.9853 9 22 6.98528 22 4.5H20C20 5.88071 18.8807 7 17.5 7V9ZM14.2115 7.57181C15.0315 8.44933 16.2022 9 17.5 9V7C16.7789 7 16.1304 6.69602 15.6728 6.20632L14.2115 7.57181ZM8.41654 12.377L15.4916 7.72461L14.3927 6.05353L7.31768 10.7059L8.41654 12.377ZM6.90519 11.8148C6.96673 12.0314 7 12.261 7 12.5H9C9 12.0743 8.94061 11.6608 8.82904 11.2681L6.90519 11.8148ZM7 12.5C7 12.7679 6.95822 13.0241 6.88156 13.2635L8.78629 13.8734C8.92533 13.4392 9 12.9773 9 12.5H7ZM16.0788 17.7691L8.38153 12.7317L7.28632 14.4052L14.9836 19.4426L16.0788 17.7691ZM17.5 17C16.5627 17 15.6896 17.2876 14.9679 17.7796L16.0944 19.4322C16.4946 19.1594 16.9772 19 17.5 19V17ZM22 21.5C22 19.0147 19.9853 17 17.5 17V19C18.8807 19 20 20.1193 20 21.5H22ZM17.5 26C19.9853 26 22 23.9853 22 21.5H20C20 22.8807 18.8807 24 17.5 24V26ZM13 21.5C13 23.9853 15.0147 26 17.5 26V24C16.1193 24 15 22.8807 15 21.5H13ZM13.4662 19.5036C13.1675 20.1064 13 20.7851 13 21.5H15C15 21.1 15.0932 20.7246 15.2582 20.3918L13.4662 19.5036ZM6.34201 15.8941L13.8146 20.7845L14.9098 19.111L7.43721 14.2206L6.34201 15.8941ZM6.20671 14.3268C5.75907 14.7453 5.16039 15 4.5 15V17C5.6873 17 6.7691 16.5389 7.57251 15.7878L6.20671 14.3268ZM4.5 15C3.11929 15 2 13.8807 2 12.5H0C0 14.9853 2.01472 17 4.5 17V15ZM2 12.5C2 11.1193 3.11929 10 4.5 10V8C2.01472 8 0 10.0147 0 12.5H2ZM4.5 10C5.18913 10 5.81153 10.2775 6.26479 10.7293L7.67664 9.31269C6.86381 8.50256 5.73963 8 4.5 8V10ZM13.5503 4.49756L6.42128 9.18543L7.52014 10.8565L14.6492 6.16865L13.5503 4.49756ZM13 4.5C13 4.86762 13.0443 5.22626 13.1283 5.57031L15.0712 5.0959C15.0248 4.90594 15 4.70655 15 4.5H13ZM17.5 0C15.0147 0 13 2.01472 13 4.5H15C15 3.11929 16.1193 2 17.5 2V0ZM22 4.5C22 2.01472 19.9853 0 17.5 0V2C18.8807 2 20 3.11929 20 4.5H22Z"
                  fill="black"
                  mask="url(#path-2-inside-1_2103_548)"
                />
              </svg>
            </FinishingText>
          )}
        </>
      )}
    </LinkContainer>
  );
};

LinkTextField.propTypes = {
  children: PropTypes.node,
  value: PropTypes.string,
  questionId: PropTypes.string,
  onChange: PropTypes.func,
  loseLife: PropTypes.func,
  gameOver: PropTypes.func,
  revealClues: PropTypes.func,
  revealTitleOrArtistClues: PropTypes.func,
  answers: PropTypes.array,
  totalLives: PropTypes.number,
  cluesRevealed: PropTypes.bool,
  solvedFields: PropTypes.number,
  scoreTimer: PropTypes.number,
  handleSetGameState: PropTypes.func,
  decimalTime: PropTypes.number,
  disabled: PropTypes.bool,
  revealHints: PropTypes.func,
  hints: PropTypes.any,
  revealClueHint: PropTypes.func,
  revealTitleOrArtistClueHint: PropTypes.func,
};

export default LinkTextField;
